import { Phone } from "lucide-react";
import { CONTACT } from "@/lib/api";

export const ConsultNotice = ({ className = "", testId = "consult-notice" }) => (
  <a href={CONTACT.phoneHref} data-testid={testId}
    className={`group inline-flex items-center gap-3 rounded-full border border-[#00F0FF]/40 bg-[#00F0FF]/10 py-2 pl-2 pr-5 text-sm text-white transition-colors hover:bg-[#00F0FF]/20 ${className}`}>
    <span className="relative grid h-8 w-8 shrink-0 place-items-center rounded-full bg-[#00F0FF] text-[#070B14]">
      <span className="absolute inset-0 animate-ping rounded-full bg-[#00F0FF]/40" />
      <Phone className="relative h-4 w-4" />
    </span>
    <span>For free consultation, please call: <b className="font-mono tracking-wide text-[#00F0FF]">{CONTACT.phone}</b></span>
  </a>
);
